import { getGroupsStore } from '../GroupsStore';
import { mutatorAction } from 'satcheljs';
import { GroupSubscriptionType } from 'owa-groups-shared-store/lib/schema/GroupSubscriptionType';
import { mapSubscriptionTypeToProperties } from 'owa-groups-shared-store/lib/utils/subscriptionTypeMapping';

export const groupSubscriptionStoreUpdate = mutatorAction(
    'groupSubscriptionStoreUpdate',
    function groupSubscriptionStoreUpdate(
        groupId: string,
        subscriptionType: GroupSubscriptionType
    ) {
        let groupsStore = getGroupsStore();
        let groupInformation = groupId && groupsStore.groups.get(groupId.toLowerCase());
        if (groupInformation?.groupDetails) {
            groupInformation.groupDetails.UserGroupRelationship = {
                ...groupInformation.groupDetails.UserGroupRelationship,
                ...mapSubscriptionTypeToProperties(subscriptionType),
            };
        }
    }
);
